import { render, staticRenderFns } from "./like-button.vue?vue&type=template&id=d8561622"
import script from "./like-button.vue?vue&type=script&lang=js"
export * from "./like-button.vue?vue&type=script&lang=js"
import style0 from "./like-button.vue?vue&type=style&index=0&id=d8561622&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports